<template>
  <p-vue-dialog class="p-override-dialog" @show="show" @hide="hide">
    <template #header>
      <h5 class="dialog__title">{{ $attrs.title }}</h5>
      <a
        v-if="showClose"
        href="#"
        class="dialog__close"
        @click.prevent="$emit('update:visible', false)"
      >
        <i-icon name="cancel" />
      </a>
    </template>
    <slot></slot>
    <!-- <template #footer>
      <slot name="footer">{{footer}}</slot>
    </template> -->
  </p-vue-dialog>
</template>
<script>
export default {
  props: {
    fnClose: {
      type: Function,
      default: () => {},
    },
    showClose: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      key: null,
    };
  },
  methods: {
    show() {
      // this.key = Math.random();
      // if (!window.dialogArray) window.dialogArray = [];
      // window.dialogArray.push({
      //   Key: this.key,
      //   func: () => this.$emit("update:visible", false),
      // });
      // window.history.pushState(
      //   null,
      //   null,
      //   window.location.href + "/#dialog" + this.key
      // );
      // window.isBack = false;
    },
    hide() {
      this.fnClose();
      // const myKey = window.dialogArray.findIndex((arr) => arr.Key === this.key);
      // console.log("init hide", myKey);
      // if (myKey > -1) window.dialogArray.splice(myKey, 1);
      // if (window.location.href.includes(this.key)) {
      //   window.history.back();
      //   window.isBack = true;
      // }
      /*
      dialogArray.forEach((d)=>{if(d.func)d.func()})
      1. לבצע במיון הפוך
      2. לבצע בback
      
      */
    },
  },
};
</script>

<style scoped>
.dialog__title {
  margin: 0;

  font-size: 18px;
  font-weight: normal;
  letter-spacing: 0.58px;
  color: var(--color-primary);
}

.dialog__close {
  color: var(--color-success);
}

.dialog__close:deep(.svg) {
  width: 15px;
  height: 15px;
}
</style>
